<template>
  <div id="app" v-cloak>
    <keep-alive>
      <router-view  v-if="$route.meta.keepAlive" :key="$route.fullPath" />
    </keep-alive>
    <router-view  v-if="!$route.meta.keepAlive" :key="$route.fullPath" />
    <!-- <transition name="slide-fade">
      <router-view class="pages"></router-view>
    </transition> -->
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  /* 重置样式 */
  @import url("./assets/css/common.css");

  #app {
    width: 100%;
    height: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
    box-sizing: border-box;
  }

  /* 切换页面的过渡动画 */
  /* .slide-fade-enter-active,
  .slide-fade-leave-active {
    will-change: transform;
    transition: all 500ms;
    position: absolute;
  }

  .slide-fade-enter {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  .slide-fade-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  } */

  /* 解决空白的问题就是下面这段css */
  /* .pages {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    margin: 0 auto;
  } */

  [v-cloak] {
    display: none !important;
  }

  #app .MsoNormal a {
    color: #2468f2 !important;
  }

  .Guide .content_txt img {
    max-width: 100%;
  }

  /* 超出显示省略号 */
  .Linebreak,.Linebreak-more {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    overflow: hidden;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
  }

  .Linebreak {
    -webkit-line-clamp: 2;
  }

  .Linebreak-more {
    -webkit-line-clamp: 3;
  }

  /* 现场花絮二级 */
	/*图片预览 缩略图*/
	.preview figure {
	  width: 30%;
	  margin: 1.5%;
	}

	.preview figure img {
	  width: 100%;
	}

  .preview .my-gallery{
    display: flex;
    flex-wrap: wrap;
  }

  /* swiper分页器字体颜色 */
  .gallery-top .swiper-pagination-current{
    font-size: 30px;
    color: #e55656;
  }

  /* 新闻中心详情页 图片 */
  /* .NewsDetails .txt_content img{
    width: 100%;
  } */

  /* 新闻详情 */
  .NewsDetails .section-style section {
    transform: translate3d(0px, 0px, 0px) !important;
  }

  .NewsDetails .content_txt .p-style p{
    margin-top: 0 !important;
  }

  .NewsDetails .li-style li{
    list-style: circle;
  }

  /* 二级页面 的标题 和 查看更多 */
  .SpecialGuest .SpecialGuestWrap>a,
  .SpecialGuest .SpecialGuestWrap .index-more {
    display: none !important;
  }

  .subWrapper .OrganizationWrap .content{
    align-items: center !important;
  }

  /* 二级-组织机构 */
  .Organized .sub_contBox .OrganizationBox,
  .SpecialGuest .sub_contBox .GuestBox {
    background: #f3f6f9;
  }

  .Organized .OrganizationBox .title,
  .SpecialGuest .GuestBox .title {
    color: #1058bb;
  }

  .Organized .OrganizationBox .name p,
  .SpecialGuest .GuestBox .name p {
    color: #000000;
  }

  /* 表格 */
  #app .Survey .subject tr td:nth-child(2) {
    display: none;
  }

  @media screen and (min-width: 1029px) {

    /* 二级页面 */
    .Breadcrumb_box {
      width: 100%;
      border-bottom: 1px solid #ccc;
    }

    .Breadcrumb_box .el-breadcrumb {
      width: 1200px;
      margin: 0 auto;
      font-size: 16px;
      color: #151515;
      line-height: 70px;
    }

    .subWrapper .content_box {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 25px auto 0;
      overflow: hidden;
    }

    .content_box>.sidebar {
      width: 180px;
    }

    .content_box>.sidebar li {
      display: block;
      text-align: left;
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #ccc;
      color: #151515;
      padding-left: 20px;
      font-size: 16px;
      overflow: hidden;
      cursor: pointer;
    }

    .content_box>.sidebar li.on,
    .content_box>.sidebar li:hover {
      color: #3a5aa8;
      background: url(./assets/image/secico_1.png) left no-repeat;
    }

    .content_box .content_txt {
      width: 980px;
      margin-bottom: 30px;
    }

    /* 时间戳 */
    .Agenda .el-timeline-item__wrapper {
      top: -6px;
    }

    /* 二级 menu */
    .Index .pc_banner {
      display: none;
    }

    .subWrapper .pc_menu>img {
      width: 450px;
    }

    .subWrapper .pc_menu {
      height: 60px !important;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 10;
    }

    .subWrapper .menu .link-active::after,
    .subWrapper .menu .router-link-active::after {
      bottom: 0 !important;
    }

    .SpecialGuest .SpecialGuestWrap .index-title {
      display: none;
    }

    /* 首页公共 */
    .Index .content {
      margin: 40px auto 95px;
    }

    .Index .contentBox {
      width: 1200px;
      margin: 0 auto;
    }

    .Index .IndexContent .index-title {
      line-height: 48px;
      letter-spacing: 4px;
      color: #ffffff;
      font-size: 40px;
      font-weight: normal;
      font-stretch: normal;
      display: inline-block;
    }

    .Index .IndexContent .index-title::after {
      height: 6px;
      background-image: linear-gradient(-90deg,
        #cd4e90 0%,
        #f38f3f 100%);
      display: block;
      content: ' ';
      margin-top: 19px;
    }

    /* 查看更多 */
    .index-more {
      width: 200px;
      line-height: 50px;
      background-image: linear-gradient(240deg,
        #cd4e90 0%,
        #f38f3f 100%);
      /* margin: 0 auto 95px; */
      margin: 15px auto 0;
      display: block;
      font-size: 20px;
      color: #ffffff;
      text-align: center;
    }

    /* 首页 大会概况 */
    .survey_cont p {
      margin-top: 30px;
    }

    .survey_cont p:last-child {
      margin-top: 0;
    }

    /* 首页 特邀嘉宾 */
    .Index .SpecialGuestWrap li {
      position: relative;
      top: 100vh;
    }

    /* 首页 现场花絮swiper */
    .IndexLiveHighlights .swiper-slide {
      text-align: center;
      font-size: 18px;
      height: calc((100% - 20px) / 2);

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
    }

    .IndexLiveHighlights .swiper-slide img{
      height: 100%;
      width: 100%;
    }

    /* 首页 主题演讲 */
    .IndexKeynoteSpeech .swiper-slide {
      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
    }

    /* swiper前进后退按钮 */
    .swiper-button-prev{
      left: 0;
    }

    .swiper-button-next{
      right: 0;
    }

    /* 二级页面 特邀嘉宾 */
    .SpecialGuest .content_box li {
      color: #000000 !important;
    }

    /* 特邀嘉宾弹窗 */
    .GuestCoverWrap {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, .8);
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 12;
    }

    .guest_coverbox>span {
      background: url(./assets/image/close_icon.png) no-repeat center center;
      background-size: contain;
      display: inline-block;
      width: 30px;
      height: 30px;
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }

    .guest_coverbox {
      width: 60%;
      height: 50%;
      background: rgba(0, 0, 0, .5);
      color: #ffffff;
      padding-right: 50px;
      position: relative;
    }

    .top_coverinfo {
      display: flex;
      height: 100%;
    }

    .top_coverinfo>img {
      width: 220px;
      height: 270px;
      margin: -20px 0 0 -20px;
    }

    .top_coverinfo .info {
      margin-left: 50px;
      height: 100%;
    }

    .top_coverinfo .info h5 {
      font-size: 24px;
      font-weight: normal;
      margin: 50px 0 22px;
    }

    .top_coverinfo .info p {
      font-size: 14px;
      line-height: 28px;
    }

    .guest_coverbox .guest_intr {
      margin-top: 26px;
      max-height: 60%;
      overflow: hidden;
      overflow-y: auto;
      text-align: justify;
      line-height: 28px;
      font-size: 14px;
    }

    /* 特邀嘉宾 icon样式 */
    .video-style,
    .news-style,
    .paper-style {
      padding-left: 34px;
      color: #FFFFFF;
    }

    .video-style {
      background: url(assets/image/guest_video_icon.png) no-repeat left center;
      background-size: 23px 14px;
    }

    .news-style {
      background: url(assets/image/guest_news_icon.png) no-repeat 2px center;
      background-size: 18px 21px;
    }

    .paper-style {
      background: url(assets/image/guest_paper_icon.png) no-repeat left center;
      background-size: 22px 20px;
    }

    .dashed-style {
      height: 1px;
      border-top: 1px dashed #FFFFFF;
      margin: 40px 0 20px;
    }

    /* 二级新闻中心 */
    .NewsDetails .content_txt p,
    .NewsDetails .content_txt .txt_content {
      line-height: 30px;
      /* text-align: left;
      margin-top: 15px; */
      font-size: 17px;
    }

    #app table {
      font-size: 16px !important;
      margin: 0 auto;
      width: 100%;
    }

    /* 滚动条 */
    ::-webkit-scrollbar {
      width: 14px;
      height: 14px;
    }

    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-thumb {
      border-radius: 999px;
      border: 5px solid transparent;
    }

    ::-webkit-scrollbar-track {
      box-shadow: 1px 1px 5px rgba(0, 0, 0, .2) inset;
    }

    ::-webkit-scrollbar-thumb {
      min-height: 20px;
      background-clip: content-box;
      box-shadow: 0 0 0 5px rgba(0, 120, 215, .8) inset;
    }

    ::-webkit-scrollbar-corner {
      background: transparent;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1024px) {

    /* 首页 公共 */
    .Index .content {
      /* width: 85%; */
      padding: 0 .3rem;
      margin: 0 auto 1.3rem;
    }

    #swiper-container2 .index-title {
      font-size: .56rem;
      font-weight: normal;
      font-stretch: normal;
      color: #ffffff;
      padding: .45rem 0 .45rem .3rem;
      display: inline-block;
    }

    /* 特邀嘉宾弹窗 */
    .GuestCoverWrap {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, .8);
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 12;
    }

    .GuestCoverWrap>span {
      background: url(./assets/image/close_icon.png) no-repeat center center;
      background-size: contain;
      display: inline-block;
      width: .4rem;
      height: .4rem;
      position: fixed;
      top: .6rem;
      right: .6rem;
    }

    .guest_coverbox {
      width: 80%;
      height: 70%;
      background: rgba(0, 0, 0, .5);
      color: #ffffff;
      padding: .3rem;
    }

    .top_coverinfo {
      display: flex;
    }

    .top_coverinfo img {
      width: 2.2rem;
      height: 2.7rem;
      margin: -.6rem 0 0 -.6rem;
    }

    .top_coverinfo .info {
      margin-left: .3rem;
    }

    .top_coverinfo .info h5 {
      font-size: .36rem;
      line-height: .48rem;
      font-weight: normal;
      margin-bottom: .3rem;
    }

    .top_coverinfo .info p {
      font-size: .24rem;
      line-height: .32rem;
    }

    .guest_coverbox .cover_contentbox {
      font-size: .28rem;
      line-height: .48rem;
      margin-top: .5rem;
      max-height: 60%;
      overflow: hidden;
      overflow-y: scroll;
      text-align: justify;
    }

    /* 特邀嘉宾 icon样式 */
    .video-style,
    .news-style,
    .paper-style {
      padding-left: .52rem;
      font-size: .28rem;
      line-height: .56rem;
      color: #FFFFFF;
    }

    .video-style {
      background: url(assets/image/guest_video_icon.png) no-repeat left center;
      background-size: .32rem .2rem;
    }

    .news-style {
      background: url(assets/image/guest_news_icon.png) no-repeat left center;
      background-size: .26rem .32rem;
    }

    .paper-style {
      background: url(assets/image/guest_paper_icon.png) no-repeat left center;
      background-size: .32rem .3rem;
    }

    .dashed-style {
      height: 1px;
      border-top: 1px dashed #FFFFFF;
      margin: .4rem 0 .2rem;
    }

    /* 二级页面 */
    .subWrapper {
      width: 100%;
      height: 100%;
      background: url(./assets/image/sub_bg.jpg) no-repeat;
      background-size: 100% 100%;
    }

    .subWrapper .LogoMenuWrapper {
      padding: 0;
    }

    .Index .IndexLogoMenu {
      background: rgba(0, 0, 0, .3) !important;
    }

    .subWrapper .sub_contBox {
      overflow: hidden;
      margin-top: .2rem;
      height: calc(100% - 1.2rem);
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      position: static;
    }

    .Guide .sub_contBox {
      height: calc(100% - 2rem);
    }

    .contbox_top {
      background: #FFFFFF;
      border-radius: 8px 8px 0 0;
      padding: 0 .3rem .3rem;
      margin: 0 .3rem .3rem;
      overflow: hidden;
      min-height: 8rem;
    }

    .contbox_scroll {
      /* min-height: calc(100% + 1px); */
      min-height: 100%;
    }

    /* 现场花絮 */
    .Live-menu .LogoMenuWrapper{
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9;
      background: url(./assets/image/sub_bg.jpg) no-repeat;
      background-size: 100%;
    }

    .LiveHighlights .sub_contBox{
      height: 100% !important;
      margin: 0 0 0 !important;
    }

    .LiveHighlights .pswp img{
      height: auto !important;
    }

    /* 渐变标题 */
    .sub_title {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: .36rem 0 .45rem;
    }

    .sub_title img {
      width: .6rem;
      height: .3rem;
    }

    .sub_title>span {
      font-size: .48rem;
      letter-spacing: 5px;
      color: transparent;
      background: linear-gradient(to left, #0ebc7d, #4433b7);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      margin: 0 .23rem;
    }

    /* 查看更多 */
    .index-more {
      width: 2rem;
      line-height: .6rem;
      background-image: linear-gradient(240deg,
        #cd4e90 0%,
        #f38f3f 100%);
      margin: .3rem auto 0;
      display: block;
      font-size: .28rem;
      color: #ffffff;
      text-align: center;
    }

    /* 时间戳 */
    .Agenda .el-timeline-item__wrapper {
      padding-left: .3rem;
      top: -8px;
    }

    .Agenda .el-timeline-item__node--normal {
      width: .16rem;
      height: .16rem;
      left: 1px;
    }

    .Agenda .el-timeline-item__timestamp {
      font-size: .28rem;
      color: #000000;
    }

    /* 二级新闻中心详情 */
    .NewsDetails .txt_content p,
    .NewsDetails .txt_content {
      font-size: .28rem;
      line-height: .4rem;
      /* color: #333333; */
    }

    .NewsDetails .txt_content img{
      max-width: 100%;
    }

    #app table {
      width: 100% !important;
    }

    #app table span {
      font-size: .28rem !important;
    }

    #app .NewsDetails .table-txt-left td p {
      text-align: left !important;
    }

    #app table p {
      text-align: center !important;
    }

  }
</style>



// WEBPACK FOOTER //
// src/App.vue